import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import {NotificationManager} from '../components/common/react-notifications';
import FieldError from '../components/FieldError';
import TextField from '../components/TextField';
import Api from '../services/Api';
import Select from 'react-select';
import {values} from 'lodash';

class UserGroupForm extends React.Component {
  createGroup = async values => {
    const {t, fireFetchData} = this.props;
    const {name, kycPolicy, loyaltyPolicy} = values;
    try {
      await Api.invoke(
        'POST',
        '/admin-ui/user-groups',
        {
          name,
          attributes: {
            kyc_id: kycPolicy.value,
            loyalty_id: loyaltyPolicy.value,
          },
        }
      );
      NotificationManager.success(t('User group created successfully'), t('Message'));
      ModalManager.close({
        isOpen: false
      });
      fireFetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updateGroup = async values => {
    const {t, userGroup, fireFetchData} = this.props;
    const {name, kycPolicy, loyaltyPolicy} = values;
    try {
      await Api.invoke(
        'PATCH',
        '/admin-ui/user-groups',
        {
          id: userGroup.id,
          name,
          attributes: {
            kyc_id: kycPolicy.value,
            loyalty_id: loyaltyPolicy.value,
          },
        },
      );
      NotificationManager.success(t('User group updated successfully'), t('Message'));
      ModalManager.close({
        isOpen: false
      });
      fireFetchData();
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  }

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      placeholder={this.props.t('Select')}
    />
  );

  render() {
    const {t, kycPolicies, loyaltyPolicies, userGroup} = this.props;
    const kycPolicyList = values(kycPolicies);
    const loyaltyPolicyList = values(loyaltyPolicies);
    return(
      <FinalForm
        initialValues={{
          name: userGroup ? userGroup.name : undefined,
          kycPolicy: userGroup ?
            {label: kycPolicies[userGroup.attributes.kyc_id].name, value: userGroup.attributes.kyc_id} :
            {label: kycPolicyList[0].name, value: kycPolicyList[0].id},
          loyaltyPolicy: userGroup ?
            {label: loyaltyPolicies[userGroup.attributes.loyalty_id].name, value: userGroup.attributes.loyalty_id} :
            {label: loyaltyPolicyList[0].name, value: loyaltyPolicyList[0].id},
        }}
        onSubmit={userGroup ? this.updateGroup : this.createGroup}
        render={({handleSubmit, submitting, hasValidationErrors}) => {
          return (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col>
                  <TextField item={{
                    name: 'name',
                    i18n: t('User Group Name'),
                    type: 'text',
                    required: true,
                  }}/>
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col>
                  <span>{t('Kyc Policy')}</span>
                  <Field
                    name="kycPolicy"
                    component={this.ReactSelectAdapter}
                    options={kycPolicyList.map(policy => ({label: policy.name, value: policy.id}))}
                    closeMenuOnSelect={false}
                  />
                  <FieldError name='kycPolicy'/>
                </Col>
              </Row>
              <Row>
                <Col>
                  <span>{t('Trade Fee Policy')}</span>
                  <Field
                    name="loyaltyPolicy"
                    component={this.ReactSelectAdapter}
                    options={loyaltyPolicyList.map(policy => ({label: policy.name, value: policy.id}))}
                    closeMenuOnSelect={false}
                  />
                  <FieldError name='loyaltyPolicy'/>
                </Col>
              </Row>
              <Row style={{marginTop: 20}}>
                <Col>
                  <LoaderButton
                    color="success"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}>
                    {userGroup ? t('Update') : t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(UserGroupForm);
